import { render, staticRenderFns } from "./PromptSelectCategory.vue?vue&type=template&id=41bdaee5&scoped=true&"
import script from "./PromptSelectCategory.vue?vue&type=script&lang=js&"
export * from "./PromptSelectCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bdaee5",
  null
  
)

export default component.exports